import { breakpoints } from '../../../../cssVariables'
import { AssetProps } from '../types'
import NextImage, { StaticImageData } from 'next/image'
import React from 'react'

export const Image: React.FC<AssetProps> = props => {
  const {
    imgClassName,
    onClick,
    onLoad: onLoadFromProps,
    sizes: sizesFromProps,
    resource,
    priority,
    fill,
    src: srcFromProps,
    alt: altFromProps,
    width: widthFromProps,
    height: heightFromProps,
  } = props

  const [isLoading, setIsLoading] = React.useState(true)

  let width: number | undefined = widthFromProps
  let height: number | undefined = heightFromProps
  let alt = altFromProps
  let src: StaticImageData | string | undefined = srcFromProps

  if (!src && resource && typeof resource !== 'string') {
    width = resource.width
    height = resource.height
    alt = resource.alt
    src = `${process.env.NEXT_PUBLIC_SERVER_BASE_URL}/assets/${resource?.filename}`
  }

  const sizes =
    sizesFromProps ||
    Object.entries(breakpoints)
      .map(([, value]) => `(max-width: ${value}px) ${value}px`)
      .join(', ')

  return (
    <React.Fragment>
      <NextImage
        className={`bg-transparent ${imgClassName}`}
        src={src || ''}
        alt={alt || ''}
        onClick={onClick}
        onLoad={() => {
          setIsLoading(false)
          if (typeof onLoadFromProps === 'function') {
            onLoadFromProps()
          }
        }}
        fill={fill}
        width={!fill ? width : undefined}
        height={!fill ? height : undefined}
        sizes={sizes}
        priority={priority}
      />
    </React.Fragment>
  )
}
